module.exports = __webpack_public_path__ + "assets/webgl/art_109_L0.jpg.dxt.bfca7e11.ktx";